import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/sections/Header";
import { Hero } from "@/sections/Hero";
import { Marquee } from "@/sections/Marquee";
import { Institutional } from "@/sections/Institutional";
import { Pillars } from "@/sections/Pillars";
import { Planning } from "@/sections/Planning";
import { Segments } from "@/sections/Segments";
import { Differential } from "@/sections/Differential";
import { Calculator } from "@/sections/Calculator";
import { Clause } from "@/sections/Clause";
import { Faq } from "@/sections/Faq";
import { Positioning } from "@/sections/Positioning";
import { Contact } from "@/sections/Contact";
import { Footer } from "@/sections/Footer";

export default function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="min-h-screen bg-cream font-sans text-ink">
            <Header />
            <main>
                <Hero />
                <Marquee />
                <Institutional />
                <Pillars />
                <Planning />
                <Segments />
                <Differential />
                <Calculator />
                <Clause />
                <Faq />
                <Positioning />
                <Contact />
            </main>
            <Footer />
            <Toaster
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#181C21",
                        color: "#F5F1EA",
                        border: "1px solid #363E4A",
                        borderRadius: "4px",
                    },
                }}
            />
        </div>
    );
}
